import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";

import { Box, Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useState } from "react";
import DummyOfferLetter from "../../features/offerLetters/DummyOfferLetter";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageOfferLetters = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Offer Letters</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Offer
          Letters
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label={`Offer Letter 1`} {...a11yProps(0)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <DummyOfferLetter />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ManageOfferLetters;
